import * as a from '../../../actions'
import validateForm from './validators/Form'
import validatePhoto from './validators/photo'
import validateCheckin from './validators/checkin'
import validateRecognition from './validators/recognition'
import {
  warning_alert, success_alert,
  error_alert, off_alert,
} from '../../../utils/constants'

const validators = {
  form: validateForm,
  photo: validatePhoto,
  checkin: validateCheckin,
  recognition: validateRecognition,
}

export const initialState = {
  attempt: 1,
  needs_revision: false,
  finished: false,
  errors: new Set(),
  step: 0,
  pages_to_answer: [],
  pages_wrongs: [],
  pageIds: {},
  alert: off_alert,
  earned_for_winning: {
    new_medals: [],
    new_titles: [],
    user: {},
  },
  wrongs: 0,
  target: 0,
}

const finishAllPages = state => state.step === (state.pages_to_answer.length - 1)

const isAllPagesRight = pages_wrongs => pages_wrongs.length === 0

const valid_answer = (state, payload) => {
  const current_page = state.pages_to_answer[state.step]
  const validate = validators[current_page.page_type]
  const { valid, is_correct_answer, errors } = !validate ? {
    valid: true, is_correct_answer: true, errors: new Set(),
  } : validate(current_page, payload)
  if (valid) {
    const pages_wrongs = is_correct_answer ?
      state.pages_wrongs :
      state.pages_wrongs.concat(current_page)
    if (finishAllPages(state)) {
      if (isAllPagesRight(pages_wrongs) || state.target === 1) {
        return {
          ...state,
          finished: true,
        }
      }
      return {
        ...state,
        attempt: state.attempt + 1,
        step: 0,
        pages_to_answer: pages_wrongs,
        pages_wrongs: [],
        alert: warning_alert,
        wrongs: state.wrongs + 1,
      }
    }
    return {
      ...state,
      step: state.step + 1,
      pages_wrongs,
      alert: is_correct_answer ? success_alert : error_alert([...errors][0]),
    }
  }
  return {
    ...state,
    alert: error_alert([...errors][0]),
  }
}

const pageIds = (payload) => {
  const to_retun = {}
  payload.forEach((page, step) => { to_retun[step] = page.id })
  return to_retun
}

export const progressUpdate = (state = initialState, { type, payload }) => {
  switch (type) {
    case a.PAGE_ANSWERED:
      return valid_answer(state, payload)
    case a.MISSION_ANSWER_INIT:
      return {
        ...initialState,
        needs_revision: payload.needs_revision,
        pages_to_answer: payload.mission_pages,
        pageIds: pageIds(payload.mission_pages),
        target: payload.target || initialState.target,
      }
    case a.MISSION_ALERT_SHOWED:
      return {
        ...state,
        alert: off_alert,
      }
    case a.MISSION_ANSWER_DONE_SUCCEEDED:
      return {
        ...state,
        earned_for_winning: {
          ...state.earned_for_winning,
          ...payload,
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/index.jsx